export default __webpack_public_path__ + "static/media/02_gallery_NB-H3801_image.fcf76d62.jpg";